"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiChatBubble = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const chat_helpers_1 = require("@/components/domains/chat/chat.helpers");
const chat_styles_1 = require("@/components/domains/chat/chat.styles");
/**
 * 상대방/AI가 보낸 메시지 버블. 좌측 정렬.
 */
let AiChatBubble = class AiChatBubble extends (0, chat_helpers_1.withChatBubbleImage)(lit_1.LitElement) {
    render() {
        return (0, chat_helpers_1.renderChatBubbleShell)(this, (0, lit_1.html) `
        <slot></slot>
      `);
    }
};
AiChatBubble.styles = [chat_styles_1.chatBubbleStyles];
AiChatBubble = __decorate([
    (0, decorators_js_1.customElement)('mm-ai-chat-bubble')
], AiChatBubble);
exports.AiChatBubble = AiChatBubble;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYWktY2hhdC1idWJibGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJhaS1jaGF0LWJ1YmJsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBc0M7QUFDdEMscURBQWlEO0FBRWpELHlFQUFtRztBQUNuRyx1RUFBd0U7QUFFeEU7O0dBRUc7QUFFSSxJQUFNLFlBQVksR0FBbEIsTUFBTSxZQUFhLFNBQVEsSUFBQSxrQ0FBbUIsRUFBQyxnQkFBVSxDQUFDO0lBRy9ELE1BQU07UUFDSixPQUFPLElBQUEsb0NBQXFCLEVBQzFCLElBQUksRUFDSixJQUFBLFVBQUksRUFBQTs7T0FFSCxDQUNGLENBQUE7SUFDSCxDQUFDOztBQVRNLG1CQUFNLEdBQUcsQ0FBQyw4QkFBZ0IsQ0FBQyxDQUFBO0FBRHZCLFlBQVk7SUFEeEIsSUFBQSw2QkFBYSxFQUFDLG1CQUFtQixDQUFDO0dBQ3RCLFlBQVksQ0FXeEI7QUFYWSxvQ0FBWSJ9